import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AnalyticEdit } from 'src/app/analytic/model/analyticEdit';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { AnalyticService } from 'src/app/core/service/analytic.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticViewResolver
{
  constructor(
    private analyticService: AnalyticService,
    private authService: AuthenticationService,
    private router: Router)
  {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<AnalyticEdit | null>
  {
    const id = +route.paramMap.get('id');

    if (!id || isNaN(id))
    {
      void this.router.navigate(['/not-found']);
      return of(null);
    }

    return this.analyticService.getAnalyticById(id).pipe(
      map((analytic) =>
      {
        if (!this.isAnalyticAccessibleToOrganization(analytic, this.authService.currentUser?.organizationId))
        {
          void this.router.navigate(['/not-found']);
          return null;
        }

        return analytic;
      }),
      catchError(() =>
      {
        void this.router.navigate(['/not-found']);
        return of(null);
      })
    );
  }

  private isAnalyticAccessibleToOrganization(analytic: AnalyticEdit, userOrganizationId: number): boolean
  {
    if (analytic.enabled === false)
    {
      return false;
    }

    if (analytic.allOrganizations === true)
    {
      return true;
    }

    return analytic.organizations != null &&
      analytic.organizations.some((org: any) =>
        org.id == userOrganizationId || org.organizationId == userOrganizationId);
  }
}
